import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { PluginConfigurationComponent } from '@valtimo/plugin';
import {
  BehaviorSubject,
  combineLatest,
  filter,
  map,
  Observable,
  Subscription,
  take,
} from 'rxjs';
import { GriffieConfig, GriffieType } from '../../models';
import { GriffiePluginService } from '../../services';

@Component({
  standalone: false,
  selector: 'valtimo-griffie-configuration',
  templateUrl: './griffie-configuration.component.html',
  styleUrls: ['./griffie-configuration.component.scss'],
})
export class GriffieConfigurationComponent
  implements PluginConfigurationComponent, OnInit, OnDestroy {
  @Input() save$: Observable<void>;
  @Input() disabled$: Observable<boolean>;
  @Input() pluginId: string;
  @Input() prefillConfiguration$: Observable<GriffieConfig>;
  @Output() valid: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() configuration: EventEmitter<GriffieConfig> = new EventEmitter<GriffieConfig>();

  mappedPrefill$: Observable<GriffieConfig>;

  private saveSubscription!: Subscription;

  private readonly formValue$ = new BehaviorSubject<GriffieConfig | null>(null);
  private readonly valid$ = new BehaviorSubject<boolean>(false);

  constructor(
    private readonly griffiePluginService: GriffiePluginService
  ) { }

  ngOnInit(): void {
    this.openSaveSubscription();
    this.setMappedPrefill();
  }

  ngOnDestroy() {
    this.saveSubscription?.unsubscribe();
  }

  formValueChange(formValue: GriffieConfig): void {
    this.formValue$.next(formValue);
    this.handleValid(formValue);
  }

  griffieTypeFormChange(formValue: GriffieType): void {
  }

  private handleValid(formValue: GriffieConfig): void {
    const validForm = !!(
      formValue.configurationTitle
    );
    const griffieTypen = formValue.griffieProperties || [];
    const validGriffieTypen = griffieTypen.filter(
      type =>
        !!(
          type.bronorganisatie &&
          type.groupMail &&
          type.candidateGroup
        )
    );
    const valid = validForm && griffieTypen.length === validGriffieTypen.length;
    this.valid$.next(valid);
    this.valid.emit(valid);
  }

  private openSaveSubscription(): void {
    this.saveSubscription = this.save$?.subscribe(save => {
      combineLatest([this.formValue$, this.valid$])
        .pipe(take(1))
        .subscribe(([formValue, valid]) => {
          const formValueToSave: GriffieConfig = {
            ...formValue,
            griffieProperties: formValue.griffieProperties.map(griffie => {
              const griffieToReturn: GriffieType = { ...griffie };

              return {
                ...griffieToReturn,
              };
            }),
          };
          if (valid) {
            this.configuration.emit(formValueToSave);
          }
        });
    });
  }

  private setMappedPrefill(): void {
    this.mappedPrefill$ = this.prefillConfiguration$.pipe(
      filter(prefill => !!prefill),
      map(prefill => ({
        ...prefill,
        griffieProperties: prefill.griffieProperties.map(griffieType => ({
          ...griffieType,
        })),
      })),
    );
  }
}
